import { Link } from "react-router-dom";
import { useUser } from "../contexts/UserContext";

export default function MainPage() {
  const { user } = useUser();

  return (
    <div
  className="relative min-h-screen w-full flex flex-col justify-end items-center bg-black pb-40"
  style={{ minHeight: "100vh" }}
>
      {/* 배경 이미지 */}
      <img
        src="/astronaut.png"
        alt="메인 배경"
        className="absolute inset-0 w-full h-full object-contain object-center z-0"
        style={{ pointerEvents: "none", userSelect: "none" }}
      />
      <div className="absolute inset-0 bg-black bg-opacity-40 z-10" />
      {/* 컨텐츠(하단 고정) */}
      <div className="relative z-20 flex-1 flex flex-col items-center justify-end w-full px-6">
        {/* 버튼 컨테이너 */}
        <div className="flex w-full max-w-xs gap-3 mb-8">
          {!user ? (
            <>
              <Link to="/signup" className="w-1/2">
                <button className="w-full bg-black bg-opacity-80 text-white text-base font-bold py-2 rounded-lg shadow hover:bg-gray-800 transition">
                  회원가입
                </button>
              </Link>
              <Link to="/board" className="w-1/2">
                <button className="w-full bg-white bg-opacity-70 text-black text-base font-bold py-2 rounded-lg shadow hover:bg-gray-300 transition">
                  둘러보기
                </button>
              </Link>
            </>
          ) : (
            <>
              <Link to="/board" className="w-full">
                <button className="w-full bg-white bg-opacity-70 text-black text-base font-bold py-2 rounded-lg shadow hover:bg-gray-300 transition">
                  둘러보기
                </button>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
